export default __webpack_public_path__ + "static/media/thum3.b7ddb6f9.jpg";